var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", [
    _c(
      "div",
      { staticClass: "clearfix", attrs: { slot: "header" }, slot: "header" },
      [
        _c("span", { staticClass: "header-item" }, [
          _vm._v("Replacement Requests"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ring-card__header-buttons" },
          [
            _c("RefreshButton", {
              nativeOn: {
                click: function ($event) {
                  return _vm.loadRequests()
                },
              },
            }),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "card-content",
      },
      [
        _c(
          "el-table",
          {
            ref: "replacementsTable",
            staticClass: "requests",
            staticStyle: { width: "100%", cursor: "pointer" },
            attrs: { data: _vm.requests },
            on: { "cell-click": _vm.toggleRowExpansion },
          },
          [
            _c("el-table-column", {
              attrs: { type: "expand" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("customer-request-logs", {
                        attrs: { request: scope.row },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                sortable: "",
                prop: "status",
                label: "Status",
                width: "140",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "indicator",
                          class: scope.row.status,
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row.status_name ||
                                  _vm.getStatus(scope.row.status)
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                width: "220",
                sortable: "",
                prop: "created_at",
                label: _vm.$t("requests.uuid"),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("uppercase")(scope.row.uuid)) +
                          "\n          "
                      ),
                      _c(
                        "div",
                        { staticStyle: { color: "#C0C0C0" } },
                        [
                          _c("time-zone-formatter", {
                            attrs: { "current-time": scope.row.created_at },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: _vm.$t("requests.product"), "min-width": "150" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "span",
                        { staticStyle: { "word-break": "break-word" } },
                        [_vm._v(_vm._s(scope.row.old_product))]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "old_device_id",
                "class-name": "important",
                label: _vm.$t("requests.device_id"),
                "min-width": "160",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "tracking_id",
                "class-name": "important",
                label: "Tracking ID",
                "min-width": "150",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "return_label_id",
                "class-name": "important",
                label: "Return Label",
                "min-width": "160",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                sortable: "",
                prop: "agent",
                "min-width": "150",
                label: _vm.$t("requests.agent"),
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { "min-width": "100", index: 99, label: "" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm.canCancel(scope.row)
                        ? _c("cancel-request-button", {
                            attrs: { request: scope.row },
                            on: { reload: _vm.loadRequests },
                          })
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }